import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import useToast from 'hooks/useToast';
import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { IExtractedProFormaDownload } from 'types/db/ExtractedProForma';

export const DOWNLOAD_NOT_STORED_MESSAGE = 'The original workbook is no longer stored.';
export const DOWNLOAD_FAILED_MESSAGE = 'The download failed. Try again.';

export interface IDownloadExtractedProFormaVariables {
    organizationId: string;
    dealId: number;
    extractedProFormaId: number;
}

const getDownloadErrorMessage = (error: unknown): string => (
    isAxiosError(error) && error.response?.status === 404 ? DOWNLOAD_NOT_STORED_MESSAGE : DOWNLOAD_FAILED_MESSAGE
);

/**
 * Starts a browser download from a presigned link. Navigation (not fetch) keeps the stored file name and needs no bucket CORS rule.
 */
const startBrowserDownload = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const useDownloadExtractedProForma = () => {
    const { showError } = useToast();

    return useMutation({
        mutationFn: async ({ organizationId, dealId, extractedProFormaId }: IDownloadExtractedProFormaVariables) => {
            const res = await axiosInstance.get<IExtractedProFormaDownload>(
                API_ENDPOINTS.EXTRACTED_PRO_FORMA_DOWNLOAD(organizationId, dealId, extractedProFormaId),
            );
            startBrowserDownload(res.data.downloadUrl);
        },
        onError: (error: unknown) => showError(getDownloadErrorMessage(error)),
    });
};

export default useDownloadExtractedProForma;
